import { render, staticRenderFns } from "./theme-color.vue?vue&type=template&id=376d7805"
import script from "./theme-color.vue?vue&type=script&lang=js"
export * from "./theme-color.vue?vue&type=script&lang=js"
import style0 from "./theme-color.vue?vue&type=style&index=0&id=376d7805&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports